import { ComponentProps } from "react";
import { NavLink } from "react-router-dom";
import styled, { css } from "styled-components";
import { shade0, shade300, shade700, shade950 } from "../../styles/tokens";
import { normalStyles } from "../body/Body.Parts";
import { BorderBar, Content } from "../tab/Tab.Parts";

// TEXT

// STYLES
const tabBaseStyles = css<Pick<Props, "$noWrap">>`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  ${({ $noWrap }) =>
    $noWrap &&
    css`
      flex-shrink: 0;
      white-space: nowrap;
    `}

  &:first-of-type {
    ${BorderBar}, ${Content} {
      margin-left: 0;
      padding-left: 0;
    }
  }
`;

export const Tab = styled(NavLink)<Props>`
  ${tabBaseStyles}
  text-decoration: none;
  color: ${shade300};
  ${normalStyles};

  ${({ $disabled }) =>
    $disabled
      ? css`
          color: ${shade700};
          background: ${shade950};
          cursor: not-allowed;
        `
      : css`
          &[aria-current="page"] {
            color: ${shade0};
            cursor: default;
          }

          &:hover:not([aria-current="page"]) {
            color: ${shade0};
          }

          &:focus-visible:not([aria-current="page"]) {
            ${Content} {
              outline: 1px solid ${shade0};
              outline-offset: 1px;
              box-shadow: 0 0 0 2px ${shade950};
            }
          }
        `}
`;

export const SkeletonTab = styled.div<Pick<Props, "$noWrap">>`
  ${tabBaseStyles}
`;

// DATA

// TYPES
export type Props = ComponentProps<typeof NavLink> & {
  label?: string;
  $disabled?: boolean;
  $noWrap?: boolean;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
